<div class="content content-terms">
    <button class="close" (click)="close()">
    <i class="icon-close"></i>
  </button>
    <iframe [src]="iframeURL | srcSanitizer" allow="clipboard-read; clipboard-write"></iframe>
</div>